import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from '../../../../middlewares/api/actions';
import {
    FILE_MAPPING_WIZARD_CHECK_CIRCULAR_DEPENDENCIES,
    FILE_MAPPING_WIZARD_CHECK_MANDATORY_FIELDS,
    FILE_MAPPING_WIZARD_COLUMN_SELECT,
    FILE_MAPPING_WIZARD_COMPONENTS_HIDE,
    FILE_MAPPING_WIZARD_COMPONENTS_SHOW,
    FILE_MAPPING_WIZARD_CSV_HEADER_GET,
    FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE,
    FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW,
    FILE_MAPPING_WIZARD_CUBE_READ,
    FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE,
    FILE_MAPPING_WIZARD_FORM_CHANGE,
    FILE_MAPPING_WIZARD_HIDE, FILE_MAPPING_WIZARD_PLUGIN_TO_CSV_CONVERT,
    FILE_MAPPING_WIZARD_PLUGINS_GET, FILE_MAPPING_WIZARD_RESET_FIELDS,
    FILE_MAPPING_WIZARD_SHOW,
    FILE_MAPPING_WIZARD_STEP_SET,
    FILE_MAPPING_WIZARD_CALC_FIELD_GET,
    FILE_MAPPING_WIZARD_CSV_FORM_CREATE_TEMP_TABLE,
    FILE_MAPPING_WIZARD_DELETE_TEMP_TABLE,
    FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_SHOW,
    FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_HIDE
} from './actions';
import { FILE_MAPPING_WIZARD_DOWNLOAD_CALC_FIELD_RULES } from './export-rules-form/actions';
import { combineReducers } from 'redux';
import fileMappingWizardCubeSelectorReducer from './cube-selector/reducer';
import {
    FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET,
    FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET
} from './cube-selector/actions';
import {
    FILE_MAPPING_WIZARD_CSV_FORM_CHANGE,
    FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET,
    FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT,
    FILE_MAPPING_WIZARD_PLUGIN_FORM_SUBMIT,
} from './csv-form/actions';
import _ from 'lodash';
import fileMappingWizardCsvRowListReducer from './csv-row-list/reducer';
import fileMappingWizardCsvColValueListReducer from './csv-column-value-list/reducer';
import fileMappingWizardCalcColValueListReducer from './calculated-field-value-list/reducer';
import fileMappingWizardCubeComponentListReducer from './cube-component-list/reducer';
import {
    FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD,
    FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL,
    FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE,
    FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL,
    FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT,
} from './component-mapper/actions';
import { FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT } from './cube-component-list/actions';
import {
    FILE_MAPPING_WIZARD_COMPONENT_LIST_CODELIST_CODES_ITEMS_PAGE_READ,
    FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_HIDE,
    FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_SHOW,
    FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_SAVE,
    FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_TYPE_SET,
    FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_VALUE_SET
} from './component-list/actions';
import {
    FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_SHOW,
    FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_HIDE,
    FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_CHANGE,
    FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES
} from './import-csv-form/actions';
import {
    FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_CHANGE,
    FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_HIDE,
    FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_SHOW,
} from './export-rules-form/actions';
import { FILE_MAPPING_WIZARD_ADD_FIELD } from './add-field/actions';
import {
    FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SHOW,
    FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_HIDE,
    FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHECK_HEADER,
    FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHANGE,
    FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SUBMIT,
} from './select-sort/actions'
import { 
    FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SHOW,
    FILE_MAPPING_WIZARD_CSV_HEADER_FORM_HIDE,
    FILE_MAPPING_WIZARD_CSV_HEADER_FORM_CHANGE,
    FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SUBMIT,
} from './csv-header-edit/actions';
import {
    CODELIST_ORDER_ANNOTATION_KEY,
    getItemSchemeFromSdmxJsonFactory,
    getSdmxStructuresFromSdmxJson,
    SDMX_JSON_CODELIST_ITEMS_KEY
} from '../../../../utils/sdmxJson';
import { getCurrentNodeConfig } from '../../../../middlewares/current-node-config/middleware';
import {
    checkComponentsHaveCircularDependencies,
    createMapping,
    getComponentExpression,
    getComponentsFromMappedCubeComponents,
    getCubeComponentType,
    getDefaultMapping,
    getInitCalculatedValue,
    getInitConcatenatedValue,
    mappingTypeCalculated,
    mappingTypeConcat,
    mappingTypeDefault,
    mappingTypeFixed
} from './utils';

import fileMappingWizardAddFieldModalReducer from './add-field/reducer';
import fileMappingWizardPreviewRowListReducer from './add-field/preview-row-list/reducer';

export const FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION = 0;
export const FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD = 1;
export const FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING = 2;
export const FILE_MAPPING_WIZARD_STEP_NAME = 3;

export const DOT_STAT_COLUMN_NAME = "_FREQ_";

const fileMappingWizardReducer = combineReducers({
    components: combineReducers({
        cubeSelector: fileMappingWizardCubeSelectorReducer,
        csvRowList: fileMappingWizardCsvRowListReducer,
        csvColumnValueList: fileMappingWizardCsvColValueListReducer,
        calcColumnValueList: fileMappingWizardCalcColValueListReducer,
        cubeComponentList: fileMappingWizardCubeComponentListReducer,
        addField: fileMappingWizardAddFieldModalReducer,
        previewRowList: fileMappingWizardPreviewRowListReducer
    }),
    shared: (
        state = {
            csvForm: {
                file: null,
                xmlFile: null,
                separator: ';',
                delimiter: null,
                hasHeader: true,
                hasDotStatFormat: false
            },
            importRulesForm: {
                file: null
            },
            exportRulesForm: {
                name: null
            },
            CsvHeaderFormData: {
                nameValue: '',
                originalName: ''
            },
            fileFormat: 'csv',
            cubeId: null,
            cubeCode: null,
            cube: null,
            fileServerPath: null,
            tempTableName: null,
            xmlServerPath: null,
            secondServerPath: null,
            thirdServerPath: null,
            csvServerPath: null,
            configuredPlugins: null,
            csvHeader: null,
            addedHeaders: null,
            components: [],
            selectedColumnName: null,
            selectedColumnOriginalName: null,
            selectedColumnNameTempTable: null,
            selectedCubeComponentCode: null,
            selectedMapping: null,
            mandatoryFieldsChecked: false,
            componentValueDefinitionFormVisible: false,
            componentValueDefinition: null,
            componentCodelistCodesItemsPage: null,
            componentCodelistCodesItemsCount: null,
            mappingHasCircularDependencies: false,
            importCalcRulesShow: false,
            exportCalcRulesShow: false,
            mergedHeader: null,
            mergedHeaderTemp: null,
            selectSortShow: false,
            csvHeaderFormVisible: false,
            checkedHeader: null,
            checkedHeaderTemp: null,
            deleteTempTable: false,
            deleteTempTableName: null,
            importedMappingRulesTemp: null,
            showModalTemptable: false
        },
        action
    ) => {
        switch (action.type) {
            case FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_SHOW:
                return {
                    ...state,
                    showModalTemptable: true
                };
            case FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_HIDE:
                return {
                    ...state,
                    showModalTemptable: false
                };
            case FILE_MAPPING_WIZARD_SHOW:
                return {
                    ...state,
                    cubeId: action.cubeId !== undefined ? action.cubeId : null,
                    cubeCode: action.cubeCode !== undefined ? action.cubeCode : null,
                    cube: null,
                    components: [],
                    selectedCubeComponentCode: null,
                    selectedMapping: null,
                    fileFormat: 'csv',
                    csvForm: {
                        file: null,
                        xmlFile: null,
                        separator: ';',
                        delimiter: null,
                        hasHeader: true,
                        hasDotStatFormat: false
                    },
                    fileServerPath: null,
                    xmlServerPath: null,
                    csvServerPath: null,
                    mandatoryFieldsChecked: false,
                    componentValueDefinitionFormVisible: false,
                    componentValueDefinition: null,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                    mappingHasCircularDependencies: false,
                };
            case FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SHOW:
                return {
                    ...state,
                    csvHeaderFormVisible: true,
                    CsvHeaderFormData: {
                        nameValue: action.listComponent.name.toUpperCase(),
                        beforeEditName: action.listComponent.name.toUpperCase(),
                        originalName: action.listComponent.originalName ? action.listComponent.originalName.toUpperCase() : action.listComponent.name.toUpperCase()
                    }
                }
            case FILE_MAPPING_WIZARD_CSV_HEADER_FORM_HIDE:
                return {
                    ...state,
                    csvHeaderFormVisible: false,
                    CsvHeaderFormData: {
                        nameValue: '',
                        originalName: ''
                    }
                }
            case FILE_MAPPING_WIZARD_CSV_HEADER_FORM_CHANGE:
                const csvHeaderFormData = _.cloneDeep(state.CsvHeaderFormData);
                return {
                  ...state,
                  CsvHeaderFormData: _.merge(csvHeaderFormData, action.fields)
                }
            case FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SHOW:
                const headerFlat = state.checkedHeader ? state.checkedHeader : _.flatten(Object.keys(state.mergedHeader).map(key => state.mergedHeader[key]))
                    .map(col => col.name);
                return {
                    ...state,
                    selectSortShow: true,
                    checkedHeaderTemp: headerFlat,
                    mergedHeaderTemp: _.cloneDeep(state.mergedHeader)
                };
            case FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_HIDE:
                return {
                    ...state,
                    selectSortShow: false,
                    mergedHeaderTemp: null
                };
            case FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHECK_HEADER:
                const newCheckedList = state.mergedHeaderTemp.map((item, i) => {
                    var tempHeaderObject = Object.assign({}, item);
                    if (action.header.indexOf(state.mergedHeaderTemp[i].name) !== -1) {
                        tempHeaderObject.selected = true;
                    } else {
                        tempHeaderObject.selected = false;
                    }
                    return tempHeaderObject;
                });
                return {
                    ...state,
                    checkedHeaderTemp: action.header,
                    mergedHeaderTemp: newCheckedList
                };
            case FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_CHANGE:
                var arrangedHeaders = action.cols;
                var arrangedChecked = [...state.checkedHeaderTemp].sort(function (a, b) { return arrangedHeaders.map(x => x.name).indexOf(a) - arrangedHeaders.map(x => x.name).indexOf(b) })
                return {
                    ...state,
                    mergedHeaderTemp: arrangedHeaders,
                    checkedHeaderTemp: arrangedChecked
                }
            case FILE_MAPPING_WIZARD_PROCESSED_SELECT_SORT_SUBMIT:
                var checkedHeaderSort = state.mergedHeaderTemp.filter(x => x.selected).map(x => x.name)
                return {
                    ...state,
                    mergedHeader: state.mergedHeaderTemp,
                    checkedHeader: checkedHeaderSort,
                    selectSortShow: false,
                    mergedHeaderTemp: null,
                    checkedHeaderTemp: null
                }
            case FILE_MAPPING_WIZARD_CSV_FORM_CHANGE:
                return {
                    ...state,
                    csvForm: {
                        ...state.csvForm,
                        ..._.mapValues(action.fields, field => field.value)
                    },
                    fileServerPath: null,
                    xmlServerPath: null,
                    csvServerPath: null,
                    csvHeader: null,
                    components: [],
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedMapping: null,
                    mandatoryFieldsChecked: false,
                    componentValueDefinition: null,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                    mappingHasCircularDependencies: false,
                };
            case FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_CHANGE:
                return {
                    ...state,
                    importRulesForm: {
                        ...state.importRulesForm,
                        ..._.mapValues(action.fields, field => field.value)
                    }
                }
            case FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_CHANGE:
                return {
                    ...state,
                    exportRulesForm: {
                        ...state.exportRulesForm,
                        ..._.mapValues(action.fields, field => field.value)
                    }
                }
            case FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET:
                return {
                    ...state,
                    fileFormat: action.fileFormat,
                    csvForm: {
                        file: null,
                        xmlFile: null,
                        separator: ';',
                        delimiter: action.fileFormat === 'px' ? '"' : null,
                        hasHeader: true,
                        hasDotStatFormat: false
                    },
                    fileServerPath: null,
                    xmlServerPath: null,
                    csvServerPath: null,
                    csvHeader: null,
                };
            case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET:
                return {
                    ...state,
                    cubeId: action.cubeId,
                    cubeCode: action.cubeCode,
                    cube: null,
                    components: [],
                    selectedCubeComponentCode: null,
                    selectedMapping: null,
                    fileFormat: 'csv',
                    csvForm: {
                        file: null,
                        xmlFile: null,
                        separator: ';',
                        delimiter: null,
                        hasHeader: true,
                        hasDotStatFormat: false
                    },
                    fileServerPath: null,
                    xmlServerPath: null,
                    csvServerPath: null,
                    mandatoryFieldsChecked: false,
                    componentValueDefinitionFormVisible: false,
                    componentValueDefinition: null,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                    mappingHasCircularDependencies: false,
                };
            case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET:
                return {
                    ...state,
                    cubeId: null,
                    cubeCode: null,
                    cube: null,
                    components: [],
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedCubeComponentCode: null,
                    selectedMapping: null,
                    fileFormat: 'csv',
                    csvForm: {
                        file: null,
                        xmlFile: null,
                        separator: ';',
                        delimiter: null,
                        hasHeader: true,
                        hasDotStatFormat: false
                    },
                    fileServerPath: null,
                    xmlServerPath: null,
                    csvServerPath: null,
                    mandatoryFieldsChecked: false,
                    componentValueDefinitionFormVisible: false,
                    componentValueDefinition: null,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                    mappingHasCircularDependencies: false,
                };
            case FILE_MAPPING_WIZARD_COLUMN_SELECT:
                return {
                    ...state,
                    selectedColumnName: action.columnName,
                    selectedColumnOriginalName: action.originalColumnName,
                    selectedColumnNameTempTable: action.tempTableName,
                    selectedMapping: null,
                };
            case FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT:
                return {
                    ...state,
                    selectedCubeComponentCode: action.cubeComponentCode,
                    selectedMapping: null,
                };
            case FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD: {
                const cubeComponentType = getCubeComponentType(state.cube.components, action.cubeComponentCode);
                const selectedMapping = createMapping(action.originalColumnName !== '' ? action.originalColumnName : action.columnName, action.cubeComponentCode, cubeComponentType,
                    action.mappingType, null, action.tempTableName, action.originalColumnName !== '' ? action.columnName : null);
                return {
                    ...state,
                    selectedMapping: selectedMapping,
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedCubeComponentCode: null,
                    components: [
                        ...state.components,
                        selectedMapping
                    ],
                };
            }
            case FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL:
                const componentCanBeMapped = (cubeComponentCode) => {
                    return state.components
                        .map(mapping => mapping.CubeComponentCode)
                        .indexOf(cubeComponentCode) < 0;
                }
                return {
                    ...state,
                    components: [
                        ...state.mergedHeader.filter(function(mh) { return mh.selected; })
                            .filter(columnNameToBeMapped =>
                                state.components
                                    .map(mappedComponents => mappedComponents.ColumnName)
                                    .indexOf(columnNameToBeMapped.name) < 0)
                            .map(columnNameToBeMapped => {
                                const relatedCubeComponentCodeArr =
                                    [
                                        ...state.cube.components.dimensions,
                                        ...state.cube.components.timeDimensions,
                                        ...state.cube.components.attributes,
                                        ...state.cube.components.measures
                                    ]
                                        .filter(cubeComp =>
                                            cubeComp.Code === columnNameToBeMapped.name &&
                                            componentCanBeMapped(cubeComp.Code));
                                return relatedCubeComponentCodeArr.length > 0
                                    ? createMapping(columnNameToBeMapped.originalName !== '' ? columnNameToBeMapped.originalName : columnNameToBeMapped.name, relatedCubeComponentCodeArr[0].Code,
                                        relatedCubeComponentCodeArr[0].cubeComponentType, mappingTypeDefault, null, columnNameToBeMapped.added ? state.tempTableName : null, columnNameToBeMapped.originalName !== '' ? columnNameToBeMapped.name : null)
                                    : null;
                            })
                            .filter(comp => comp !== null),
                        ...state.components
                    ],
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedCubeComponentCode: null,
                    selectedMapping: null,
                };
            case FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE:
                return {
                    ...state,
                    components:
                        state.components
                            .filter(({ ColumnName, CubeComponentCode }) =>
                                ColumnName !== action.columnName || CubeComponentCode !== action.cubeComponentCode)
                            .map(comp => ({ ...comp }))
                };
            case FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL:
                return {
                    ...state,
                    components: [],
                    selectedMapping: null,
                };
            case FILE_MAPPING_WIZARD_HIDE:
                return {
                    csvForm: {
                        file: null,
                        xmlFile: null,
                        separator: ';',
                        delimiter: null,
                        hasHeader: true,
                        hasDotStatFormat: false
                    },
                    fileFormat: 'csv',
                    cubeId: null,
                    cubeCode: null,
                    cube: null,
                    fileServerPath: null,
                    xmlServerPath: null,
                    csvServerPath: null,
                    csvHeader: null,
                    components: [],
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedCubeComponentCode: null,
                    selectedMapping: null,
                    mandatoryFieldsChecked: false,
                    componentValueDefinitionFormVisible: false,
                    componentValueDefinition: null,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                    mappingHasCircularDependencies: false,
                    addedHeaders: null,
                    checkedHeader: null,
                    deleteTempTable: state.tempTableName ? true : false,
                    deleteTempTableName: state.tempTableName,
                    CsvHeaderFormData: {
                        nameValue: '',
                        originalName: ''
                    }
                };
            case FILE_MAPPING_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT: {
                const selectedMapping = state.components.filter(comp =>
                    comp.ColumnName === action.mapping.ColumnName &&
                    comp.CubeComponentCode === action.mapping.CubeComponentCode)[0];
                return {
                    ...state,
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedCubeComponentCode: null,
                    selectedMapping: selectedMapping,
                };
            }
            case FILE_MAPPING_WIZARD_CHECK_MANDATORY_FIELDS:
                const mappedCubeComponents = (state.components || []).map((el) => el.CubeComponentCode);
                const cubeComponents = [
                    ...state.cube.components.dimensions,
                    ...state.cube.components.timeDimensions,
                    ...state.cube.components.attributes.filter((el) => el.IsMandatory)
                ].map((el) => el.Code);

                return {
                    ...state,
                    mandatoryFieldsChecked: cubeComponents.every(
                        (v) => mappedCubeComponents.includes(v))
                };
            case FILE_MAPPING_WIZARD_CHECK_CIRCULAR_DEPENDENCIES:
                return {
                    ...state,
                    mappingHasCircularDependencies: checkComponentsHaveCircularDependencies(state.components)
                }

            case FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_SHOW: {
                const newComponentValueDefinition = getDefaultMapping(action.component);
                return {
                    ...state,
                    componentValueDefinitionFormVisible: true,
                    componentValueDefinition: newComponentValueDefinition,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                };
            }
            case FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_SHOW: {
                return {
                    ...state,
                    importCalcRulesShow: true
                }
            }
            case FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_SHOW: {
                return {
                    ...state,
                    exportCalcRulesShow: true
                }
            }
            case FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES_HIDE: {
                return {
                    ...state,
                    importCalcRulesShow: false,
                    importRulesForm: {
                        file: null
                    }
                }
            }
            case FILE_MAPPING_WIZARD_CSV_EXPORT_CALCULATED_RULES_HIDE: {
                return {
                    ...state,
                    exportCalcRulesShow: false,
                    exportRulesForm: {
                        name: null
                    },
                }
            }
            case FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_HIDE:
                return {
                    ...state,
                    componentValueDefinitionFormVisible: false,
                    componentValueDefinition: null,
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                };
            case FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_TYPE_SET:
                const components = getComponentsFromMappedCubeComponents((action.cubeComponents.map(c => c.Code) || []), [state.componentValueDefinition.cubeComponent.name], false);
                const concatenatedValues = action.valueDefinitionType === mappingTypeConcat
                    ? [getInitConcatenatedValue(components[0].name)]
                    : null;
                const calculatedValue = action.valueDefinitionType === mappingTypeCalculated
                    ? getInitCalculatedValue(action.cubeComponents, components[0].name, state.componentValueDefinition.CubeComponentCode)
                    : null
                return {
                    ...state,
                    componentValueDefinition: {
                        ...state.componentValueDefinition,
                        mappingValue: {
                            mappingType: action.valueDefinitionType,
                            fixedValue: "",
                            concatenatedValues: concatenatedValues,
                            calculatedValue: calculatedValue,
                        }
                    },
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemPage: null,
                    componentCodelistCodesItemsCount: null,
                };

            case FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_VALUE_SET: {
                const mappingType = state.componentValueDefinition.mappingValue.mappingType;
                let fixedValue = "";
                let concatenatedValues = [];
                let calculatedValue = null;
                switch (mappingType) {
                    case mappingTypeFixed: {
                        fixedValue = action.value;
                        break;
                    }
                    case mappingTypeConcat: {
                        concatenatedValues = action.value.map((v, index) => {
                            return ({ ...v, idx: index })
                        });
                        break;
                    }
                    case mappingTypeCalculated: {
                        calculatedValue = _.cloneDeep(state.componentValueDefinition.mappingValue.calculatedValue);
                        if (action.value.logicalOperator) {
                            calculatedValue.logicalOperator = action.value.logicalOperator;
                        } else if (action.value.defaultValue) {
                            calculatedValue.defaultValue = action.value.defaultValue;
                        } else if (action.value.componentValue) {
                            const block = calculatedValue.blocks[action.value.blockIdx];
                            block.componentValue = action.value.componentValue.text;
                        } else if (action.value.blocks) {
                            calculatedValue.blocks = action.value.blocks.map((b, index) => {
                                return ({ ...b, idx: index })
                            });
                        } else {
                            const block = calculatedValue.blocks[action.value.blockIdx];
                            if (block) {
                                if (action.value.conditions) {
                                    block.conditions = action.value.conditions.map((c, index) => {
                                        return ({ ...c, idx: index })
                                    });
                                } else if (action.value.condition && action.value.conditionIdx < block.conditions.length) {
                                    block.conditions[action.value.conditionIdx] = action.value.condition;
                                    block.conditions = block.conditions.map((c, index) => {
                                        return ({ ...c, idx: index })
                                    });
                                }
                            }
                        }
                        break;
                    }
                    default:
                        break;
                }
                return {
                    ...state,
                    componentValueDefinition: {
                        ...state.componentValueDefinition,
                        mappingValue: {
                            ...state.componentValueDefinition.mappingValue,
                            fixedValue: fixedValue,
                            concatenatedValues: concatenatedValues,
                            calculatedValue: calculatedValue
                        },
                    },
                    componentCodelistCodesItemsPage: null,
                    componentCodelistCodesItemsCount: null,
                };
            }
            case FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_SAVE: {
                const component = {
                    ColumnName: null,
                    CubeComponentCode: state.componentValueDefinition.CubeComponentCode,
                    CubeComponentType: state.componentValueDefinition.CubeComponentType,
                    MappingType: state.componentValueDefinition.mappingValue.mappingType,
                    Expression: getComponentExpression(state.componentValueDefinition.mappingValue)
                }

                const newComponents = state.components
                    .filter(comp => comp.CubeComponentCode !== component.CubeComponentCode);
                return {
                    ...state,
                    selectedColumnName: null,
                    selectedColumnNameTempTable: null,
                    selectedCubeComponentCode: null,
                    componentValueDefinition: null,
                    components: [
                        ...newComponents,
                        component
                    ],
                };
            }

            case FILE_MAPPING_WIZARD_RESET_FIELDS:
                return {
                    ...state,
                    fileServerPath: null,
                    csvServerPath: null,
                    secondServerPath: null,
                    thirdServerPath: null,
                };

            case REQUEST_START:
                switch (action.label) {
                    case FILE_MAPPING_WIZARD_CUBE_READ:
                        return {
                            ...state,
                            cube: null
                        };
                    case FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT:
                    case FILE_MAPPING_WIZARD_PLUGIN_FORM_SUBMIT:
                        return {
                            ...state,
                            fileServerPath: null,
                            csvServerPath: null,
                            secondServerPath: null,
                            thirdServerPath: null,
                        };
                    case FILE_MAPPING_WIZARD_CSV_HEADER_GET:
                        return {
                            ...state,
                            csvHeader: null
                        };
                    default:
                        return state;
                }
            case REQUEST_ERROR:
                switch (action.label) {
                    case FILE_MAPPING_WIZARD_CALC_FIELD_GET:
                        return {
                            ...state,
                            addedHeaders: null
                        }
                    case FILE_MAPPING_WIZARD_DOWNLOAD_CALC_FIELD_RULES:
                        return {
                            ...state
                        };
                    default:
                        return state;
                }
            case REQUEST_SUCCESS:
                switch (action.label) {
                    case FILE_MAPPING_WIZARD_CSV_HEADER_FORM_SUBMIT:
                        var headerIndex = state.mergedHeader.findIndex((x => x.name == state.CsvHeaderFormData.beforeEditName));
                        const clonedMergedHeader = _.cloneDeep(state.mergedHeader);
                        clonedMergedHeader[headerIndex].originalName = clonedMergedHeader[headerIndex].originalName === '' ? state.CsvHeaderFormData.originalName.toUpperCase() : clonedMergedHeader[headerIndex].originalName.toUpperCase();
                        clonedMergedHeader[headerIndex].name = state.CsvHeaderFormData.nameValue.replaceAll(' ', '_').toUpperCase();
                        var checkedHeaderIndex = state.checkedHeader.findIndex((x => x == state.CsvHeaderFormData.beforeEditName));
                        const clonedCheckedHeader = _.cloneDeep(state.checkedHeader);
                        clonedCheckedHeader[checkedHeaderIndex] = state.CsvHeaderFormData.nameValue.replaceAll(' ', '_').toUpperCase();
                        return {
                            ...state,
                            mergedHeader: clonedMergedHeader,
                            checkedHeader: clonedCheckedHeader,
                            CsvHeaderFormData: {
                                nameValue: '',
                                originalName: ''
                            },
                            csvHeaderFormVisible: false
                        }
                    case FILE_MAPPING_WIZARD_DELETE_TEMP_TABLE: {
                        return {
                            ...state,
                            tempTableName: null,
                            deleteTempTableName: null,
                            deleteTempTable: false
                        }
                    }
                    case FILE_MAPPING_WIZARD_ADD_FIELD:
                        return {
                            ...state,
                            addedHeaders: action.response[1].concat([])
                        }
                    case FILE_MAPPING_WIZARD_CALC_FIELD_GET:
                        var responseFetchAddedHeader = action.response.concat([]);
                        var objAddedHeader = responseFetchAddedHeader.map((name, idx) => ({
                            'name': name,
                            'originalName' : '',
                            'added': true,
                            'selected': true
                        }));
                        var deleted = state.mergedHeader.filter(({ name: id1 }) => !objAddedHeader.some(({ name: id2 }) => id2 === id1)).filter(obj => {
                            return obj.added === true
                        });
                        var refreshedHeader = null;
                        if (deleted.length > 0) {
                            refreshedHeader = state.mergedHeader.filter(function (el) { return el.name != deleted[0].name; });
                        } else {
                            refreshedHeader = state.mergedHeader;
                        }
                        var mergedHeaderUnited = _.unionBy(refreshedHeader, objAddedHeader, 'name');
                        if (state.importedMappingRulesTemp) {
                            var ordered = state.importedMappingRulesTemp.map((i) =>  {
                                var index = mergedHeaderUnited.map(x => x.name).indexOf(i.ColName) != -1 ? mergedHeaderUnited.map(x => x.name).indexOf(i.ColName) : mergedHeaderUnited.map(x => x.name).indexOf(i.OriginalColName);
                                if(index != -1) {
                                    mergedHeaderUnited[index].name = i.ColName;
                                    mergedHeaderUnited[index].originalName = i.OriginalColName ? i.OriginalColName : "";
                                    return mergedHeaderUnited[index];
                                }
                            });
                            ordered = ordered.map((item, idx) => ({
                                'name': item.name,
                                'originalName' : item.originalName,
                                'added': item.added,
                                'selected': state.importedMappingRulesTemp[ordered.map(x => x.name).indexOf(item.name)].Selected
                            }));
                        } else {
                            var ordered = mergedHeaderUnited;
                        }
                        return {
                            ...state,
                            addedHeaders: responseFetchAddedHeader,
                            mergedHeader: ordered,
                            checkedHeader: ordered.filter(function (x) { return x.selected === true }).map(x => x.name),
                            importedMappingRulesTemp: null
                        };
                    case FILE_MAPPING_WIZARD_CSV_IMPORT_CALCULATED_RULES:
                        var orderedResponse = action.response.sort((a, b) => a.Position - b.Position);
                        var renamedItems = action.response.filter(item => item.OriginalColName !== '' && item.OriginalColName !== null);
                        var refreshedMergedHeader = state.mergedHeader.map(function(item) {
                            var renamedIndex = renamedItems.map(x => x.OriginalColName).indexOf(item.name);
                            if(renamedIndex > -1) {
                                return {
                                    name: renamedItems[renamedIndex].ColName,
                                    originalName: item.name,
                                    added: item.added,
                                    selected: item.selected
                                }
                            } else {
                                return {
                                    ...item
                                }
                            }
                        })
                        return {
                            ...state,
                            importCalcRulesShow: false,
                            importRulesForm: {
                                file: null
                            },
                            importedMappingRulesTemp: orderedResponse,
                            mergedHeader: refreshedMergedHeader
                        }
                    case FILE_MAPPING_WIZARD_DOWNLOAD_CALC_FIELD_RULES:
                        return {
                            ...state,
                            exportCalcRulesShow: false,
                            exportRulesForm: {
                                name: null
                            },
                        };
                    case FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT:
                        const fileServerPath = action.response;
                        return {
                            ...state,
                            fileServerPath: fileServerPath,
                            csvServerPath: state.fileFormat === 'csv' ? fileServerPath : null,
                            components: [],
                            selectedColumnName: null,
                            selectedColumnNameTempTable: null,
                            selectedCubeComponentCode: null,
                            selectedMapping: null,
                            mandatoryFieldsChecked: false,
                            componentValueDefinitionFormVisible: false,
                            componentValueDefinition: null,
                            componentCodelistCodesItemsPage: null,
                            componentCodelistCodesItemsCount: null,
                            mappingHasCircularDependencies: false,
                            tempTableName: null
                        };
                    case FILE_MAPPING_WIZARD_CSV_FORM_CREATE_TEMP_TABLE:
                        const tempTableName = action.response.ReportDictionary.FILE_IMPORT_TRANSFORMATION;
                        return {
                            ...state,
                            tempTableName: tempTableName,
                            fileServerPath: null,
                            addedHeaders: null
                        };
                    //modal show table

                    case FILE_MAPPING_WIZARD_PLUGIN_FORM_SUBMIT:
                        const pluginFileServerPath = Array.isArray(action.response) ? action.response[0] : action.response;
                        const secondServerPath = Array.isArray(action.response) ? action.response[1] : null;
                        const thirdServerPath = Array.isArray(action.response) && action.response.length > 2 ? action.response[2] : null;
                        return {
                            ...state,
                            fileServerPath: pluginFileServerPath,
                            secondServerPath,
                            xmlServerPath: secondServerPath,
                            thirdServerPath,
                            tempTableName: null
                        };
                    case FILE_MAPPING_WIZARD_CSV_HEADER_GET:
                        var csvResponse = action.response.concat(
                            action.csvHasDotStatFormat
                                ? [DOT_STAT_COLUMN_NAME]
                                : []
                        )
                        return {
                            ...state,
                            csvHeader: csvResponse,
                            mergedHeader: csvResponse.map((name, idx) => ({
                                'name': name,
                                'originalName': '',
                                'added': false,
                                'selected': true
                            })),
                            checkedHeader: csvResponse
                        };
                    case FILE_MAPPING_WIZARD_CUBE_READ:
                        return {
                            ...state,
                            cube: {
                                ...action.response,
                                components: {
                                    dimensions:
                                        action.response.Dimensions
                                            .filter(dim => !dim.IsTimeSeriesDim)
                                            .map(dim => ({
                                                ...dim,
                                                cubeComponentType: 'Dimension'
                                            })),
                                    timeDimensions:
                                        action.response.Dimensions
                                            .filter(dim => dim.IsTimeSeriesDim)
                                            .map(dim => ({
                                                ...dim,
                                                cubeComponentType: 'TimeDimension'
                                            })),
                                    tidAttributes:
                                        action.response.Attributes
                                            .filter(attr => attr.IsTid)
                                            .map(attr => ({
                                                ...attr,
                                                cubeComponentType: 'Attribute'
                                            })),
                                    attributes:
                                        action.response.Attributes
                                            .filter(attr => !attr.IsTid)
                                            .map(attr => ({
                                                ...attr,
                                                cubeComponentType: 'Attribute'
                                            })),
                                    measures:
                                        action.response.Measures
                                            .map(meas => ({
                                                ...meas,
                                                cubeComponentType: 'Measure'
                                            }))
                                }
                            }
                        };
                    case FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE:
                        return {
                            csvForm: {
                                file: null,
                                xmlFile: null,
                                separator: ';',
                                delimiter: null,
                                hasHeader: true,
                                hasDotStatFormat: false
                            },
                            importRulesForm: {
                                file: null
                            },
                            exportRulesForm: {
                                name: null
                            },
                            CsvHeaderFormData: {
                                nameValue: '',
                                originalName: ''
                            },
                            fileFormat: 'csv',
                            cubeId: null,
                            cubeCode: null,
                            cube: null,
                            fileServerPath: null,
                            xmlServerPath: null,
                            csvServerPath: null,
                            csvHeader: null,
                            components: [],
                            selectedColumnName: null,
                            selectedColumnNameTempTable: null,
                            selectedCubeComponentCode: null,
                            selectedMapping: null,
                            mandatoryFieldsChecked: false,
                            componentValueDefinitionFormVisible: false,
                            componentValueDefinition: null,
                            componentCodelistCodesItemsPage: null,
                            componentCodelistCodesItemsCount: null,
                            mappingHasCircularDependencies: false,
                            addedHeaders: null
                        };
                    case FILE_MAPPING_WIZARD_PLUGIN_TO_CSV_CONVERT:
                        return {
                            ...state,
                            csvServerPath: action.response.outputFilePath,
                            csvForm: {
                                ...state.csvForm,
                                separator: action.response.csvSeparator || ",",
                                delimiter: (action.response.csvDelimiter === "\n" ? null : action.response.csvDelimiter) || null,
                                hasHeader: action.response.csvHasHeader || false
                            }
                        };
                    case FILE_MAPPING_WIZARD_PLUGINS_GET:
                        return {
                            ...state,
                            configuredPlugins: action.response
                        };
                    case FILE_MAPPING_WIZARD_COMPONENT_LIST_CODELIST_CODES_ITEMS_PAGE_READ: {

                        const codes = getItemSchemeFromSdmxJsonFactory(
                            SDMX_JSON_CODELIST_ITEMS_KEY,
                            getCurrentNodeConfig(action).annotations,
                            CODELIST_ORDER_ANNOTATION_KEY
                        )(getSdmxStructuresFromSdmxJson(action.response)[0]).codes || [];

                        const isInvisibleItem = item => {
                            return item.annotations && (
                                item.annotations.find(annot =>
                                    annot.id === "INVISIBLE" &&
                                    annot.title === "INVISIBLE" &&
                                    annot.type === "INVISIBLE"
                                ) !== undefined
                            );
                        };

                        let componentCodes = [];

                        if (action.componentName) {
                            const component = [...state.cube.Attributes, ...state.cube.Dimensions].find(c => c.Code === action.componentName);
                            componentCodes = component.codes;
                        } else {
                            componentCodes = (state.componentValueDefinition.cubeComponent.codes || []);
                        }

                        const codelistCodesItemsPage = codes
                            .filter(item => !isInvisibleItem(item))
                            .filter(item => componentCodes.includes(item.id));

                        return {
                            ...state,
                            componentCodelistCodesItemsPage: codelistCodesItemsPage,
                            componentCodelistCodesItemsCount: Number(action.header["x-total-count"]),
                        };
                    }
                    default:
                        return state;
                }
            default:
                return state;
        }
    },
    local: (
        state = {
            isVisible: false,
            isCubeComponentsVisible: false,
            isComponentsVisible: false,
            step: FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,
            name: null,
            tid: null,
            description: null
        },
        action
    ) => {
        switch (action.type) {
            case FILE_MAPPING_WIZARD_COMPONENTS_SHOW:
                return {
                    ...state,
                    isComponentsVisible: true
                };
            case FILE_MAPPING_WIZARD_COMPONENTS_HIDE:
                return {
                    ...state,
                    isComponentsVisible: false
                };
            case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_SET:
                return {
                    ...state,
                    name: `MAPP_${new Date().getMilliseconds()}_${action.cubeCode.toUpperCase()}`,
                };
            case FILE_MAPPING_WIZARD_CUBE_SELECTOR_CUBE_UNSET:
                return {
                    ...state,
                    name: null
                };
            case FILE_MAPPING_WIZARD_STEP_SET:
                return {
                    ...state,
                    step: action.step
                };
            case FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW:
                return {
                    ...state,
                    isCubeComponentsVisible: true
                };
            case FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE:
                return {
                    ...state,
                    isCubeComponentsVisible: false
                };
            case FILE_MAPPING_WIZARD_FORM_CHANGE:
                const {
                    name,
                    tid,
                    description
                } = action.fields;
                return {
                    ...state,
                    name: name !== undefined ? name : state.name,
                    tid: tid !== undefined ? tid : state.tid,
                    description: description !== undefined ? description : state.description
                };
            case FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE:
                return {
                    ...state,
                    step: FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION
                };
            case FILE_MAPPING_WIZARD_SHOW:
                return {
                    ...state,
                    isVisible: true,
                    step: action.cubeId ? FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD : FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,
                    name: action.cubeCode ? `MAPP_${new Date().getMilliseconds()}_${action.cubeCode.toUpperCase()}` : null
                };
            case FILE_MAPPING_WIZARD_HIDE:
                return {
                    ...state,
                    isVisible: false,
                    isCubeComponentsVisible: false,
                    step: FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,
                    name: null,
                    description: null,
                    tid: null,
                    isComponentsVisible: false,
                    CsvHeaderFormData: {
                        nameValue: '',
                        originalName: ''
                    }
                };
            case REQUEST_START:
                switch (action.label) {
                    default:
                        return state;
                }
            case REQUEST_ERROR:
                switch (action.label) {
                    default:
                        return state;
                }
            case REQUEST_SUCCESS:
                switch (action.label) {
                    case FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE:
                        return {
                            ...state,
                            isVisible: false,
                            isCubeComponentsVisibile: false,
                            isComponentsVisible: false,
                            step: FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,
                            name: null,
                            description: null,
                            tid: null
                        };
                    default:
                        return state;
                }
            default:
                return state;
        }
    }
});

export default fileMappingWizardReducer;
